import { render, staticRenderFns } from "./addCapitalExpenditure.vue?vue&type=template&id=17525423&scoped=true"
import script from "./addCapitalExpenditure.vue?vue&type=script&lang=js"
export * from "./addCapitalExpenditure.vue?vue&type=script&lang=js"
import style0 from "./addCapitalExpenditure.vue?vue&type=style&index=0&id=17525423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17525423",
  null
  
)

export default component.exports